import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FormInputText from '../../../../../common/Forms/FormTextField';
import { useDispatch } from 'react-redux';
import {
  setPostalAddress,
  setPostalCity,
  setState,
  setPostalZip,
} from '../../../../../../redux/organization/organizationTabs/addressAndContacts/addressAndContactsSlice';

const OptionalPostalAddress = (props) => {
  const dispatch = useDispatch();
  const { control, register, errors } = props;

  return (
    <>
      <Typography
        variant='h5'
        style={{ marginBottom: '-10px', marginTop: '-10px' }}
      >
        Optional Postal Address :
      </Typography>
      <Grid container spacing={2} style={{ marginTop: '0px' }}>
        <Grid item xs={12} sm={3}>
          <FormInputText
            name='postalAddress'
            type='text'
            control={control}
            errors={!!errors.postalAddress}
            helperText={errors?.postalAddress?.message}
            label='Address'
            register={register('postalAddress', {
              onChange: (e) => dispatch(setPostalAddress(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormInputText
            name='postalCity'
            type='text'
            control={control}
            errors={!!errors.postalCity}
            helperText={errors?.postalCity?.message}
            label='City'
            register={register('postalCity', {
              onChange: (e) => dispatch(setPostalCity(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormInputText
            name='state'
            type='text'
            control={control}
            errors={!!errors.state}
            helperText={errors?.state?.message}
            label='State'
            register={register('state', {
              onChange: (e) => dispatch(setState(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormInputText
            name='postalZip'
            type='number'
            control={control}
            errors={!!errors.postalZip}
            helperText={errors?.postalZip?.message}
            label='Zip'
            register={register('postalZip', {
              onChange: (e) => dispatch(setPostalZip(e.target.value)),
            })}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default OptionalPostalAddress;
